import { AIForMeTool, sortingOptions, SortOption } from "lib/models/aiforme-models";
import { AmazonianInformation } from "lib/models/oui-models";
import { FeedbackModelRecord, GetItemResponsePagination } from "lib/services/catalogical-models";
import { UserInformation } from "lib/services/user-information-service";
import { useState } from "react";

// Interface that defines the shape of the state used for security order handling.
interface AiForMeSearchListState {
  userFeedbacks: Record<string, FeedbackModelRecord>;
  data: AIForMeTool[] | undefined;
  error: Error | undefined;
  searchText: string | undefined;
  searchInputValue: string;
  selectedCategories: string[] | undefined;
  selectedJobFamilies: string[] | undefined;
  selectedDataClassification: string[] | undefined;
  sortBy: SortOption | undefined;
  isLoading: boolean;
  paginationInfo: GetItemResponsePagination;
  pageIndex: number;
  hasMore: boolean;
  isLoadingMore: boolean;
  showBuilderHubBanner: boolean;
  isInitialized: boolean;
}

export const useAiForMeSearchList = (
  userInfo = UserInformation.current.getCachedAmazonianInformation() as AmazonianInformation
) => {
  const [inputs, setInputs] = useState<AiForMeSearchListState>({
    data: undefined,
    error: undefined,
    searchText: undefined,
    searchInputValue: "",
    selectedCategories: undefined,
    selectedJobFamilies: undefined,
    selectedDataClassification: undefined,
    sortBy: sortingOptions[0],
    isLoading: false,
    paginationInfo: { total: 0, offset: 0, limit: 0 },
    pageIndex: 0,
    hasMore: true,
    isLoadingMore: false,
    showBuilderHubBanner: userInfo?.jobInfo.isTechnicalRole,
    isInitialized: false,
    userFeedbacks: {},
  });

  type StateKey = keyof AiForMeSearchListState;

  const updateInputs = <K extends StateKey>(field: K, value: AiForMeSearchListState[K]) => {
    setInputs((prev) => {
      if (prev[field] !== value) {
        return {
          ...prev,
          [field]: value,
        };
      }
      return prev;
    });
  };

  return { inputs, updateInputs };
};
